import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface MultipleChoiceState {
  questionText: string;
  answers: string[];
}

export const MULTIPLE_CHOICE_STEP_TYPE_NAME = "Multiple choice";

export const MULTIPLE_CHOICE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<MultipleChoiceState>>,
): ConditionType<MultipleChoiceState, Condition.MultipleChoice> => ({
  name: MULTIPLE_CHOICE_STEP_TYPE_NAME,
  description(state) {
    if (!state.questionText) return "No question configured";
    if (state.answers.length === 0)
      return `Question: "${state.questionText}" (no answers)`;
    return `"${state.questionText}" is one of: ${state.answers.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<MultipleChoiceState>) {
    return React.createElement(Details, props);
  },
  empty: { questionText: "", answers: [] },
  fromModel(model) {
    return { questionText: model.questionText, answers: model.answers };
  },
  toModel(state) {
    return {
      type: Condition.MULTIPLE_CHOICE,
      questionText: state.questionText,
      answers: state.answers,
    };
  },
  valid(state) {
    return state.questionText.length > 0 && state.answers.length > 0;
  },
});
